import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { SignatureSamlMerchantDTO } from '@app/requests/model/logalty-signature-model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
  selector: 'app-logalty-signature-async-merchant',
  templateUrl: './logalty-signature-async-merchant.component.html',
  styleUrls: ['./logalty-signature-async-merchant.component.scss'],
})
export class LogaltySignatureAsyncMerchantComponent implements OnInit {
  public isSamlOk: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public dialog: MatDialog,
    private loaderGenericService: LoaderGenericService,
    private digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loaderGenericService.showSpinner();

    const url = new URL(window.location.href);
    const pathSegments = url.pathname.split('/');
    const encryptedCode = pathSegments[pathSegments.length - 1];

    this.startAsyncSignature(encryptedCode);

    this.digitalSignatureServiceStore
      .SAMLObserver()
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        if (data) {
          this.isSamlOk = true;
          this.reinitChildComponent();
          this.loaderGenericService.stopSpinner();
        }
      });
  }

  private reinitChildComponent = (): void => {
    this.changeDetectorRef.detectChanges();
  };

  private startAsyncSignature = (encryptedCode: string): void => {
    this.digitalSignatureServiceStore
      .startAsyncSignatureMerchant(encryptedCode)
      .then(
        (data) => {
          const { operation, userHostId } = data;
          const { numOperation, legalIdentity, finacialProduct, version } = operation;
          const samlRequest: SignatureSamlMerchantDTO = {
            numOperation,
            documentId: legalIdentity,
            cif: '',
            financialProduct: finacialProduct,
            userHostId,
            version,
          };
          this.digitalSignatureServiceStore.getSamlSignatureMerchant(samlRequest);
        },
        (error) => this.displayErrorDialog(error)
      )
      .catch((error) => this.displayErrorDialog(error))
      .finally(() => this.loaderGenericService.stopSpinner());
  };

  private displayErrorDialog(error: string) {
    console.error(error);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      text: this.translate.instant('logalty.error.firmaNoPermitida'),
      icon: 'icon-ic_circle_cross',
      buttonCancel: false,
    };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }
}
